import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© Sindicato dos Empregados em Estab de Serv de Saúde Passo Fundo 2024 | CNPJ: 89.881.718/0001-48")]),_c('span',{staticClass:"version"},[_vm._v("v 7.1.1")])])}
var staticRenderFns = []

export { render, staticRenderFns }